<div class="dodo-tooltip" [class.show-content]="showContent">
	<div class="icon-content">
		<img class="icon" [src]="iconImage" (click)="showContent = !showContent" />
		<div class="content" [ngClass]="[
				position === 'top' ||
				position === 'top-left' ||
				position === 'top-center' ||
				position === 'top-right'
				? 'content-top'
				: '',
				position
			]">
			<div class="pointer">
				<div class="square"></div>
			</div>
			<div class="box">
				<div class="box-content" [innerHTML]="content"></div>
			</div>
		</div>
	</div>
	<div class="text" [innerHTML]="text"></div>
</div>